import { useState } from 'react';

export default function useDocumentCaptureHook() {
  const [state, setState] = useState({
    visible: false,
    loadUserData: false,
  });

  const actions = {
    setVisible: visibility => {
      updateState({ visible: visibility });
    },

    setLoadUserData: loadUserData => {
      updateState({ loadUserData });
    },

    onCancelModal: () => {
      actions.setVisible(false);
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
